// removed by extract-text-webpack-plugin
module.exports = {"waterfallWrapper":"StackedBarWaterfall__waterfallWrapper___1zLMH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StackedBarChart/StackedBarWaterfall/StackedBarWaterfall.less
// module id = 1247
// module chunks = 0